import React from "react";
import { FaMoneyCheckDollar, FaUsers } from "react-icons/fa6";
import { MdCampaign } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Overview = ({ totalCampaign, activeCampaigns }) => {
  const influencerDetails = useSelector(
    (store) => store?.influencer?.influencer
  );
  // const activeCampaigns = influencerDetails?.campaigns?.filter(
  //   (campaign) => campaign?.campaignStatus?.toLowerCase() === "active"
  // );
  return (
    <div className="overview">
      <Link>
        <div className="card w-100">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <p className="big_text">{totalCampaign}</p>
              <p className="small_text">Total Campaigns</p>
            </div>
            <div
              className="users"
              style={{ backgroundColor: "var(--primary-color)" }}
            >
              <MdCampaign />
            </div>
          </div>
        </div>
      </Link>
      <Link>
        <div className="card w-100">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <p className="big_text">{activeCampaigns}</p>
              <p className="small_text">Active Campaigns</p>
            </div>
            <div className="users" style={{ backgroundColor: "#80C4E9" }}>
              <MdCampaign />
            </div>
          </div>
        </div>
      </Link>
      <Link>
        <div className="card w-100">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <p className="big_text">
                {influencerDetails?.Followers?.toLocaleString()}
              </p>
              <p className="small_text">Followers</p>
            </div>
            <div className="users" style={{ backgroundColor: "#fdd69f" }}>
              <FaUsers />
            </div>
          </div>
        </div>
      </Link>
      <Link>
        <div className="card w-100">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <p className="big_text">₹ 12,567</p>
              <p className="small_text">Total Earning</p>
            </div>
            <div className="users" style={{ backgroundColor: "#604CC3" }}>
              <FaMoneyCheckDollar />
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Overview;
